import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const participantInfo = {
  state: () => ({
    participant: null,
    infoModalVisible: false,
    filter: {
      searchTerm: null,
      skip: 0,
      take: 200,
      total: 0,
      page: 1,
    },
    certificateSentUsers: [],
    certificateSchemes: []
  }),
  mutations: {
    setParticipant(state, payload) {
      state.participant = payload;
      state.infoModalVisible = true;
    },
  },
  actions: {
    async getParticipant(store, payload) {
      store.state.loading = true;
      await axios
        .post("participant/get", {
          id: payload,
        })
        .then((res) => {
          store.state.loading = false;
          store.state.users = res.data.data.certificateSentUsers
          store.state.certificates = res.data.data.certificateSchemes
          return store.commit("setParticipant", res.data.data.item);
        });
    },
  },
  getters: {},
};
export default participantInfo;



// WEBPACK FOOTER //
// ./src/store/participantInfo.js